const Hint = ({ hint, icon }: { hint: string; icon: React.ReactNode }) => {
  return (
    <div className="flex items-center gap-4">
      <div className="bg-primary rounded-full text-white p-2 sm:p-3">{icon}</div>
      <p className="text-md sm:text-lg text-left">{hint}</p>
    </div>
  );
};

export default Hint;
